<p-toast></p-toast>
<div class="mi-survey-container">
    <p-card styleClass="p-card-shadow">
        <div class="card">
            <p-table #miSurvey [value]="miSurveyData" [(selection)]="filteredDataForExport"
            dataKey="AppId" (onRowSelect)="onRowSelect($event)" (onRowUnselect)="onRowUnselect($event)" [rows]="10" [paginator]="true"
                [globalFilterFields]="['AutoId','AppID','FarmerName', 'FarmerRefund_Amount','District', 'Block', 'Village', 'CenterShare_Amount','MIArea', 'MaxSubsidy_Amount', 'ProgID', 'ProgrammeName', 'Scheme', 'StateShare_Amount', 'SubsidyToFarmer_Amount','SubsidyToVendor_Amount', 'VendorName']"
                responsiveLayout="scroll" [rowHover]="true" dataKey="AppID"
                currentPageReportTemplate="{{'SHOWING' | translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
                [showCurrentPageReport]="true">
                <ng-template pTemplate="caption">
                    <div class="flex align-items-center justify-content-between">
                        <h5 class="m-0">{{'FARMAER_APPLICATION_FOR_MI_SURVEY'| translate}}</h5>
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text"
                                (input)="miSurvey.filterGlobal($any($event.target).value, 'contains')"
                                placeholder= "{{'SEARCH'| translate}}"
                                />
                        </span>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th style="width: 3rem">
                            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                        </th>
                        <th pSortableColumn="AutoId">{{'AUTO_ID'| translate}}
                            <p-columnFilter type="text" field="AutoId" display="menu"></p-columnFilter>
                            <p-sortIcon field="AutoId"></p-sortIcon>
                        </th>
                        <th pSortableColumn="AppID">{{'APP_ID'| translate}}
                            <p-columnFilter type="text" field="AppID" display="menu"></p-columnFilter>
                            <p-sortIcon field="AppID"></p-sortIcon>
                        </th>
                        <th pSortableColumn="FarmerName">{{'FARMER_NAME'| translate}}
                            <p-columnFilter type="text" field="FarmerName" display="menu"></p-columnFilter>
                            <p-sortIcon field="FarmerName"></p-sortIcon>
                        </th>
                        <th pSortableColumn="VendorName">{{'VENDOR_NAME'| translate}}
                            <p-columnFilter type="text" field="VendorName" display="menu"></p-columnFilter>
                            <p-sortIcon field="VendorName"></p-sortIcon>
                        </th>
                        <th pSortableColumn="SubsidyToFarmer_Amount">{{'SUBSIDY_TO_FARMER_AMOUNT'| translate}}
                            <p-columnFilter type="text" field="SubsidyToFarmer_Amount" display="menu"></p-columnFilter>
                            <p-sortIcon field="SubsidyToFarmer_Amount"></p-sortIcon>
                        </th>
                        <th pSortableColumn="SubsidyToVendor_Amount">{{'SUBSIDY_TO_VENDOR_AMOUNT'| translate}}
                            <p-columnFilter type="text" field="SubsidyToVendor_Amount" display="menu"></p-columnFilter>
                            <p-sortIcon field="SubsidyToVendor_Amount"></p-sortIcon>
                        </th>
                        <th pSortableColumn="StateShare_Amount">{{'STATE_SHARE_AMOUNT'| translate}}
                            <p-columnFilter type="text" field="StateShare_Amount" display="menu"></p-columnFilter>
                            <p-sortIcon field="StateShare_Amount"></p-sortIcon>
                        </th>
                        <th pSortableColumn="CenterShare_Amount">{{'CENTER_SHARE_AMOUNT'| translate}}
                            <p-columnFilter type="text" field="CenterShare_Amount" display="menu"></p-columnFilter>
                            <p-sortIcon field="CenterShare_Amount"></p-sortIcon>
                        </th>
                        <th pSortableColumn="MaxSubsidy_Amount">{{'MAXSUBSIDY_AMOUNT'| translate}}
                            <p-columnFilter type="text" field="MaxSubsidy_Amount" display="menu"></p-columnFilter>
                            <p-sortIcon field="MaxSubsidy_Amount"></p-sortIcon>
                        </th>
                        <th pSortableColumn="FarmerRefund_Amount">{{'FARMER_REFUND_AMOUNT'| translate}}
                            <p-columnFilter type="text" field="FarmerRefund_Amount" display="menu"></p-columnFilter>
                            <p-sortIcon field="FarmerRefund_Amount"></p-sortIcon>
                        </th>
                        <th pSortableColumn="ProgID">{{'PROGRAMME_ID'| translate}}
                            <p-columnFilter type="text" field="ProgID" display="menu"></p-columnFilter>
                            <p-sortIcon field="ProgID"></p-sortIcon>
                        </th>
                        <th pSortableColumn="ProgrammeName">{{'PROGRAMME_NAME'| translate}}
                            <p-columnFilter type="text" field="ProgrammeName" display="menu"></p-columnFilter>
                            <p-sortIcon field="ProgrammeName"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Scheme">{{'SCHEME'| translate}}
                            <p-columnFilter type="text" field="Scheme" display="menu"></p-columnFilter>
                            <p-sortIcon field="Scheme"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Village">{{'VILLAGE'| translate}}
                            <p-columnFilter type="text" field="Village" display="menu"></p-columnFilter>
                            <p-sortIcon field="Village"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Block">{{'BLOCK'| translate}}
                            <p-columnFilter type="text" field="Block" display="menu"></p-columnFilter>
                            <p-sortIcon field="Block"></p-sortIcon>
                        </th>
                        <th pSortableColumn="District">{{'DISTRICT'| translate}}
                            <p-columnFilter type="text" field="District" display="menu"></p-columnFilter>
                            <p-sortIcon field="District"></p-sortIcon>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product>
                    <tr>
                        <td>
                            <p-tableCheckbox [value]="product"></p-tableCheckbox>
                        </td>
                        <td>{{product.AutoId}}</td>
                        <td>{{product.AppID}}</td>
                        <td>{{product.FarmerName}}</td>
                        <td>{{product.VendorName}}</td>
                        <td>{{product.SubsidyToFarmer_Amount}}</td>
                        <td>{{product.SubsidyToVendor_Amount}}</td>
                        <td>{{product.StateShare_Amount}}</td>
                        <td>{{product.CenterShare_Amount}}</td>
                        <td>{{product.MaxSubsidy_Amount}}</td>
                        <td>{{product.FarmerRefund_Amount}}</td>
                        <td>{{product.ProgID}}</td>
                        <td>{{product.ProgrammeName}}</td>
                        <td>{{product.Scheme}}</td>
                        <td>{{product.Village}}</td>
                        <td>{{product.Block}}</td>
                        <td>{{product.District}}</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <div class="flex align-items-center justify-content-between">
                        {{'IN_TOTAL_THERE_ARE'| translate}} {{miSurveyData ? miSurveyData.length : 0 }}{{'MI_SURVEY_APPLICATIONS_ADDED'| translate}}.
                    </div>
                </ng-template>
            </p-table>
        </div>
        <div class="card" *ngIf="filteredData.length">
            <h5><b>{{'TOTAL_NO_oF_APPLICATION_FILTERED_FOR_LOT_CREATION'| translate}}: {{ totalSelectedApp }}</b></h5>
            <div class="p-fluid p-formgrid grid">
                <div class="field col-12 md:col-4">
                    <p>{{'TOTAL_SUBSIDY_TO_FARMER_AMOUNT'| translate}}: {{ totalSubToFarmer }}</p>
                </div>
                <div class="field col-12 md:col-4">
                    <p>{{'TOTAL_SUBSIDY_TO_VEMDOR_AMOUNT'| translate}}: {{ totalSubToVendor }}</p>
                </div>
                <div class="field col-12 md:col-4">
                    <p>{{'TOTAL_FARMER_REFUND_AMOUNT'| translate}}: {{ totalFarmerRefund }}</p>
                </div>
            </div>
            <div class="flex justify-content-end">
                <button (click)="menu.toggle($event)" pButton pRipple p-button-info label="Download Filtered Lot Data" icon="pi pi-upload"></button>
                <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
            </div>
            
            <div class="card">
                <p-toolbar *ngIf="filteredData.length">
                        <ng-template pTemplate="left">
    
                        </ng-template>
                        <ng-template pTemplate="right">
                            <p-dropdown [options]="items" [(ngModel)]="selectedStatus" optionLabel="status" class="mr-3">
                            </p-dropdown>
                            <textarea id="description" [(ngModel)]="remarks" placeholder="{{'REMARKS'| translate}}" pInputTextarea required
                                rows="3" cols="20" class="mr-3"></textarea>
                            <button pButton pRipple label="{{'SUBMIT'| translate}}" (click)="handleClick()" class="p-button-help"></button>
                        </ng-template>
                </p-toolbar>
            </div>
        </div>
        
    </p-card>
</div>

<p-confirmDialog [style]="{width: '400px'}"></p-confirmDialog>